import script from "./SetGuestUsername.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetGuestUsername.vue?vue&type=script&setup=true&lang=ts"

import "./SetGuestUsername.vue?vue&type=style&index=0&id=e4ff365a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4ff365a"]])

export default __exports__